"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarCellDataKeys = exports.CalendarCellTimes = exports.CalendarCellAlignment = void 0;
var CalendarCellAlignment;
(function (CalendarCellAlignment) {
    CalendarCellAlignment["left"] = "left";
    CalendarCellAlignment["center"] = "center";
    CalendarCellAlignment["right"] = "right";
})(CalendarCellAlignment = exports.CalendarCellAlignment || (exports.CalendarCellAlignment = {}));
var CalendarCellTimes;
(function (CalendarCellTimes) {
    CalendarCellTimes["pastDate"] = "pastDate";
    CalendarCellTimes["today"] = "today";
    CalendarCellTimes["futureDate"] = "futureDate";
})(CalendarCellTimes = exports.CalendarCellTimes || (exports.CalendarCellTimes = {}));
var CalendarCellDataKeys;
(function (CalendarCellDataKeys) {
    CalendarCellDataKeys["Stertchable"] = "data-stretchable";
    CalendarCellDataKeys["TimeType"] = "data-time-type";
    CalendarCellDataKeys["Current"] = "data-current";
    CalendarCellDataKeys["Alignment"] = "data-alignment";
})(CalendarCellDataKeys = exports.CalendarCellDataKeys || (exports.CalendarCellDataKeys = {}));
//# sourceMappingURL=types.js.map